import { useRef, useEffect, useState } from "react";

export default function SignaturePad({ C, value, onChange, label="Technician Signature" }) {
  const canvasRef = useRef(null);
  const drawing   = useRef(false);
  const [isEmpty, setIsEmpty] = useState(!value);

  // Draw saved signature on mount
  useEffect(() => {
    if (value && canvasRef.current) {
      const img = new Image();
      img.onload = () => {
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        ctx.drawImage(img, 0, 0);
      };
      img.src = value;
    }
  }, []);

  const getPos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const src = e.touches ? e.touches[0] : e;
    return { x: (src.clientX - rect.left) * scaleX, y: (src.clientY - rect.top) * scaleY };
  };

  const startDraw = e => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e, canvasRef.current);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
  };

  const draw = e => {
    e.preventDefault();
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.strokeStyle = C.text;
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    const pos = getPos(e, canvasRef.current);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    setIsEmpty(false);
  };

  const endDraw = e => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    setIsEmpty(true);
    onChange(null);
  };

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
        <span style={{ fontSize:12, color:C.textSec, textTransform:"uppercase", letterSpacing:"0.05em" }}>{label}</span>
        {!isEmpty && (
          <button onClick={clear} style={{ fontSize:12, padding:"3px 10px", borderRadius:6, border:`1px solid ${C.border}`, background:"transparent", color:C.textSec, cursor:"pointer" }}>Clear</button>
        )}
      </div>
      <div style={{ border:`1.5px solid ${isEmpty ? C.border : C.green}`, borderRadius:10, overflow:"hidden", background:C.bgCard, touchAction:"none" }}>
        <canvas
          ref={canvasRef}
          width={800} height={200}
          style={{ width:"100%", height:120, display:"block", cursor:"crosshair" }}
          onMouseDown={startDraw} onMouseMove={draw} onMouseUp={endDraw} onMouseLeave={endDraw}
          onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={endDraw}
        />
      </div>
      {isEmpty && (
        <div style={{ textAlign:"center", fontSize:12, color:C.textTer, marginTop:4 }}>Sign above with finger or stylus</div>
      )}
    </div>
  );
}
